import React from 'react';
import cn from 'classnames';
import styles from './BuyButton.module.scss';

export function BuyButton({
  text = 'Оформить доступ',
  place,
  onClick,
}: {
  text?: string;
  place?: string;
  onClick?: () => void;
}) {
  return (
    <div className={cn(styles.root, styles[`root_${place}`])}>
      <button
        onClick={onClick}
        type="button"
        className={cn(styles.button, styles[`button_${place}`])}
      >
        {text}
      </button>
      <div className={cn(styles.shadow, styles[`shadow_${place}`])} />
    </div>
  );
}
